<template>
  <div>
    <h1 v-html="$t('view.component.contacts.list.sidebarAutotopup.header')"></h1>
    <div class="msg">
      <p v-html="$t('view.component.contacts.list.sidebarAutotopup.text')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RemoveAutotopupSidebar'
}
</script>

<style scoped lang="scss" src="../../assets/scss/components/_remove-account-sidebar.scss"></style>
